import React from 'react';
import { Section } from '../layout/Section';
import { Gallery } from '../features/Gallery';

/**
 * GallerySection Component
 * 
 * Wraps the Gallery component in a Section with proper heading and layout.
 * 
 * Requirements:
 * - 8.1: Display restaurant photos in a grid layout
 * - 8.7: Support adding new images without code changes
 */
export const GallerySection: React.FC = () => {
  return (
    <Section
      id="galerie"
      variant="darker"
      aria-labelledby="gallery-heading"
    >
      {/* Section Header */}
      <div className="text-center mb-12">
        <h2
          id="gallery-heading"
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4"
        >
          Galerie
        </h2>
        <div className="w-24 h-1 bg-[#c9a84c] mx-auto rounded-full" aria-hidden="true" />
        <p className="mt-4 text-gray-400 text-lg">
          Einblicke in unser Restaurant
        </p>
      </div>

      {/* Gallery Grid with Lightbox */}
      <Gallery />
    </Section>
  );
};
